export default "__VITE_ASSET__CXpYdGfF__"